import axios from '@/util/request'
//高考数据

//省控线
// /com/had-login/data/province-scores/save
// 新增和编辑
export const saveprovince = (data) => {
    return axios({
      url: '/com/had-login/data/province-scores/save',
      method: 'post',
      data
    })
  }

//   /com/had-login/data/province-scores/page
//   获取分页列表
export const pageprovince = (data) => {
    return axios({
      url: '/com/had-login/data/province-scores/page',
      method: 'post',
      data
    })
  }

//   /com/had-login/data/province-scores/deletes
//   删除(多个用英文,隔开)
export const deletesprovince = (params) => {
    return axios({
      url: '/com/had-login/data/province-scores/deletes',
      method: 'get',
      params
    })
  }

//   /com/had-login/data/province-scores/getDetail
//   获取单个详情
export const getDetailprovince = (params) => {
    return axios({
      url: '/com/had-login/data/province-scores/getDetail',
      method: 'get',
      params
    })
  }


//分段表

//   /com/had-login/data/province-segments/save
//   新增和编辑
export const savesegments = (data) => {
    return axios({
      url: '/com/had-login/data/province-segments/save',
      method: 'post',
      data
    })
  }

//   /com/had-login/data/province-segments/page
//   获取分页列表
export const pagesegments = (data) => {
    return axios({
      url: '/com/had-login/data/province-segments/page',
      method: 'post',
      data
    })
  }

  // /com/had-login/data/province-segments/deletes
  // 删除(多个用英文,隔开
  export const deletessegments = (params) => {
    return axios({
      url: '/com/had-login/data/province-segments/deletes',
      method: 'get',
      params
    })
  }

//   /com/had-login/data/province-segments/getDetail
// 获取单个详情
export const getDetailsegments = (params) => {
  return axios({
    url: '/com/had-login/data/province-segments/getDetail',
    method: 'get',
    params
  })
}

// /com/had-login/admission/admission-college/page
// 获取分页列表
export const pagepageadmission = (data) => {
  return axios({
    url: '/com/had-login/admission/admission-college/page',
    method: 'post',
    data
  })
}

// /com/had-login/admission/admission-college/deletes
// 删除(多个用英文,隔开)
export const deletesadmission = (params) => {
  return axios({
    url: '/com/had-login/admission/admission-college/deletes',
    method: 'get',
    params
  })
}

// /com/had-login/admission/admission-specialty/page
// 获取分页列表
export const pagespecialty = (data) => {
  return axios({
    url: '/com/had-login/admission/admission-specialty/page',
    method: 'post',
    data
  })
}

// /com/had-login/admission/admission-specialty/deletes
// 删除(多个用英文,隔开)
export const deletesspecialty = (params) => {
  return axios({
    url: '/com/had-login/admission/admission-specialty/deletes',
    method: 'get',
    params
  })
}

// /com/had-login/admission/admission-plan/page
// 获取分页列表
export const pageplan = (data) => {
  return axios({
    url: '/com/had-login/admission/admission-plan/page',
    method: 'post',
    data
  })
}

// /com/had-login/admission/admission-plan/deletes
// 删除(多个用英文,隔开)
export const deletesplan = (params) => {
  return axios({
    url: '/com/had-login/admission/admission-plan/deletes',
    method: 'get',
    params
  })
}

// /com/had-login/admission/accumulate-fluctuation-college/page
// 获取分页列表
export const pagecollege = (data) => {
  return axios({
    url: '/com/had-login/admission/accumulate-fluctuation-college/page',
    method: 'post',
    data
  })
}

// /com/had-login/admission/accumulate-fluctuation-specialty/page
// 获取分页列表
export const accumulatefluctuationspecialtypage = (data) => {
  return axios({
    url: '/com/had-login/admission/accumulate-fluctuation-specialty/page',
    method: 'post',
    data
  })
}

// /com/had-login/admission/admission-college/save
// 新增和编辑
export const saveadmissioncollege = (data) => {
  return axios({
    url: '/com/had-login/admission/admission-college/save',
    method: 'post',
    data
  })
}

// /com/had-login/admission/admission-college/setHidden
// 设置隐藏
export const setHidden = (data) => {
  return axios({
    url: '/com/had-login/admission/admission-college/setHidden',
    method: 'post',
    data
  })
}

// /com/had-login/admission/admission-college/getDetail
// 获取单个详情
export const getDetailcollege = (params) => {
  return axios({
    url: '/com/had-login/admission/admission-college/getDetail',
    method: 'get',
    params
  })
}

// /com/had-login/admission/admission-specialty/getDetail
// 获取单个详情
export const getDetailspecialty = (params) => {
  return axios({
    url: '/com/had-login/admission/admission-specialty/getDetail',
    method: 'get',
    params
  })
}

// /com/had-login/admission/admission-specialty/save
// 新增和编辑
export const savespecialty = (data) => {
  return axios({
    url: '/com/had-login/admission/admission-specialty/save',
    method: 'post',
    data
  })
}

// /com/had-login/data/province-scores/deleteBatch
// 删除-批量
export const deleteBatch = (data) => {
  return axios({
    url: '/com/had-login/data/province-scores/deleteBatch',
    method: 'post',
    data
  })
}

// /com/had-login/data/province-scores/updateBatch
// 审核-批量
export const updateBatch = (data) => {
  return axios({
    url: '/com/had-login/data/province-scores/updateBatch',
    method: 'post',
    data
  })
}

// /com/had-login/data/province-segments/deleteBatch
// 删除-批量
export const deleteBatchsegments = (data) => {
  return axios({
    url: '/com/had-login/data/province-segments/deleteBatch',
    method: 'post',
    data
  })
}

// /com/had-login/data/province-segments/updateBatch
// 审核-批量
export const updateBatchegments = (data) => {
  return axios({
    url: '/com/had-login/data/province-segments/updateBatch',
    method: 'post',
    data
  })
}

// /com/had-login/admission/admission-college/deleteBatch
// 删除-批量
export const deleteBatchcollege = (data) => {
  return axios({
    url: '/com/had-login/admission/admission-college/deleteBatch',
    method: 'post',
    data
  })
}

// /com/had-login/admission/admission-specialty/deleteBatch
// 删除-批量
export const deleteBatchspecialty = (data) => {
  return axios({
    url: '/com/had-login/admission/admission-specialty/deleteBatch',
    method: 'post',
    data
  })
}

// /com/had-login/admission/admission-plan/deleteBatch
// 删除-批量
export const deleteBatchplan = (data) => {
  return axios({
    url: '/com/had-login/admission/admission-plan/deleteBatch',
    method: 'post',
    data
  })
}

// /com/had-login/admission/admission-specialty/setHidden
// 设置隐藏
export const setHiddenspecialty = (data) => {
  return axios({
    url: '/com/had-login/admission/admission-specialty/setHidden',
    method: 'post',
    data
  })
}

// 专业组招生计划
// /com/had-login/admission/admission-splan/page
// 获取分页列表
export const splanpage = (data) => {
  return axios({
    url: '/com/had-login/admission/admission-splan/page',
    method: 'post',
    data
  })
}

// /com/had-login/admission/admission-splan/deleteBatch
// 删除-批量
export const splandeleteBatch = (data) => {
  return axios({
    url: '/com/had-login/admission/admission-splan/deleteBatch',
    method: 'post',
    data
  })
}

// /com/had-login/admission/admission-splan/deletes
// 删除(多个用英文,隔开)
export const splandeletes = (params) => {
  return axios({
    url: '/com/had-login/admission/admission-splan/deletes',
    method: 'get',
    params
  })
}

//院校招生计划
// /com/had-login/admission/admission-cplan/page
// 获取分页列表
export const cplanpage = (data) => {
  return axios({
    url: '/com/had-login/admission/admission-cplan/page',
    method: 'post',
    data
  })
}

// /com/had-login/admission/admission-cplan/deleteBatch
// 删除-批量
export const cplandeleteBatch = (data) => {
  return axios({
    url: '/com/had-login/admission/admission-cplan/deleteBatch',
    method: 'post',
    data
  })
}

// /com/had-login/admission/admission-cplan/deletes
// 删除(多个用英文,隔开)
export const cplandeletes = (params) => {
  return axios({
    url: '/com/had-login/admission/admission-cplan/deletes',
    method: 'get',
    params
  })
}